/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Code_Of_Ethics_DescriptionInputs */



/**
* | output |
* | --- |
* | "VEKN Code of Ethics for players and organizers." |
*
* @param {Help_Code_Of_Ethics_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const help_code_of_ethics_description = /** @type {((inputs?: Help_Code_Of_Ethics_DescriptionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Code_Of_Ethics_DescriptionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Code d'éthique de la VEKN pour les joueurs et les organisateurs.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Código ético de VEKN para jugadores y organizadores.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Código de ética da VEKN para jogadores e organizadores.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Codice etico VEKN per giocatori e organizzatori.")
	return /** @type {LocalizedString} */ ("VEKN Code of Ethics for players and organizers.")
});